import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PostCard from "./components/PostCard";
import { discoverPosts } from "@/mocks/discoverData";

const BRAND = "#FF6B35";

const tabs = ["推荐", "关注", "附近"];

const entries = [
  { icon: "ri-hotel-bed-line", label: "酒店", path: "/hotels", color: "#FF6B35", bg: "#FFF3EE" },
  { icon: "ri-route-line", label: "线路", path: "/routes", color: "#00B96B", bg: "#E8FBF2" },
  { icon: "ri-car-line", label: "租车", path: "/cars", color: "#F59E0B", bg: "#FEF9EE" },
  // TODO: 导游功能暂禁用，后期可能用到
  // { icon: "ri-user-star-line", label: "导游", path: "/guides", color: "#8B5CF6", bg: "#F3F0FF" },
];

const banners = [
  {
    img: "https://readdy.ai/api/search-image?query=Sanya%20beach%20turquoise%20sea%20white%20sand%20luxury%20resort%20hotel%20sunset%20golden%20warm%20tropical%20paradise%20aerial%20view%20cinematic&width=780&height=340&seq=bnr_s01&orientation=landscape",
    title: "三亚 · 亚龙湾",
    desc: "五一特惠，海景套餐低至 ¥1,280 起",
    badge: "五一限时",
    path: "/hotels",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Dali%20Yunnan%20Erhai%20Lake%20morning%20mist%20reflection%20mountains%20traditional%20architecture%20serene%20cinematic%20wide%20shot%20warm%20colors&width=780&height=340&seq=bnr_d02&orientation=landscape",
    title: "大理 · 苍山洱海",
    desc: "3天深度游，含住宿导游 ¥2,380 起",
    badge: "摄影打卡",
    path: "/routes",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Xiamen%20Gulangyu%20colonial%20buildings%20ocean%20sea%20view%20aerial%20bright%20sunny%20day%20greenery%20cinematic%20photography&width=780&height=340&seq=bnr_x03&orientation=landscape",
    title: "厦门 · 鼓浪屿",
    desc: "周末出发，海景房 ¥899 起",
    badge: "周末热门",
    path: "/hotels",
  },
];

// ── Banner ─────────────────────────────────────────────────
function HomeBanner({ onNav }: { onNav: (p: string) => void }) {
  const [idx, setIdx] = useState(0);
  const ref = useRef<ReturnType<typeof setInterval> | null>(null);
  useEffect(() => {
    ref.current = setInterval(() => setIdx(i => (i + 1) % banners.length), 4000);
    return () => { if (ref.current) clearInterval(ref.current); };
  }, []);
  const b = banners[idx];
  return (
    <div
      className="relative mx-4 mt-3 rounded-2xl overflow-hidden cursor-pointer active:scale-[0.99] transition-transform"
      style={{ height: 180 }}
      onClick={() => onNav(b.path)}
    >
      <img src={b.img} alt={b.title} className="w-full h-full object-cover object-center" />
      {/* Gradient overlay */}
      <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 50%)" }} />
      {/* Badge */}
      <div className="absolute top-3 left-3">
        <span className="text-xs font-bold px-2.5 py-1 rounded-full text-white" style={{ background: BRAND }}>{b.badge}</span>
      </div>
      {/* Bottom text */}
      <div className="absolute bottom-3 left-4 right-4">
        <div className="text-white font-bold text-base leading-tight mb-0.5">{b.title}</div>
        <div className="text-white/80 text-xs">{b.desc}</div>
      </div>
      {/* Dots */}
      <div className="absolute bottom-3 right-4 flex gap-1.5">
        {banners.map((_, i) => (
          <button
            key={i}
            onClick={e => { e.stopPropagation(); setIdx(i); }}
            className="rounded-full transition-all cursor-pointer"
            style={{ width: i === idx ? 16 : 5, height: 5, background: i === idx ? "#fff" : "rgba(255,255,255,0.45)" }}
          />
        ))}
      </div>
    </div>
  );
}

// ── Publish FAB ────────────────────────────────────────────
function PublishFAB() {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [tags, setTags] = useState<string[]>([]);
  const [done, setDone] = useState(false);

  const toggle = (t: string) => setTags(p => p.includes(t) ? p.filter(x => x !== t) : [...p, t]);
  const submit = () => {
    if (!text.trim()) return;
    setDone(true);
    setTimeout(() => { setDone(false); setOpen(false); setText(""); setTags([]); }, 1200);
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed right-4 z-40 flex items-center gap-2 px-4 rounded-full cursor-pointer active:scale-95 transition-all whitespace-nowrap"
        style={{ bottom: 86, height: 44, background: BRAND, boxShadow: "0 4px 18px rgba(255,107,53,0.38)" }}
      >
        <i className="ri-edit-2-line text-white" style={{ fontSize: 16 }} />
        <span className="text-white text-sm font-semibold">写游记</span>
      </button>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-end"
          style={{ background: "rgba(0,0,0,0.4)", backdropFilter: "blur(4px)" }}
          onClick={e => { if (e.target === e.currentTarget) setOpen(false); }}
        >
          <div className="w-full bg-white rounded-t-3xl" style={{ maxWidth: 480, margin: "0 auto" }}>
            <div className="w-9 h-1 rounded-full bg-gray-200 mx-auto mt-3 mb-0" />
            <div className="flex items-center justify-between px-5 pt-4 pb-3 border-b border-gray-100">
              <button onClick={() => setOpen(false)} className="text-sm text-gray-400 cursor-pointer whitespace-nowrap">取消</button>
              <span className="text-base font-bold text-gray-900">发布游记</span>
              <button
                onClick={submit}
                className="text-sm font-bold cursor-pointer whitespace-nowrap px-4 py-1.5 rounded-full transition-all"
                style={{ background: text.trim() ? BRAND : "#F3F4F6", color: text.trim() ? "#fff" : "#C0C4CC" }}
              >
                {done ? "发布中…" : "发布"}
              </button>
            </div>
            <div className="px-5 pt-4 pb-6">
              <div className="flex gap-2.5 mb-4">
                <button className="w-[72px] h-[72px] rounded-2xl flex flex-col items-center justify-center flex-shrink-0 cursor-pointer" style={{ border: "1.5px dashed #FFB99A", background: "#FFF6F2" }}>
                  <i className="ri-image-add-line" style={{ color: BRAND, fontSize: 20 }} />
                  <span className="text-xs mt-1 font-medium" style={{ color: BRAND }}>图片</span>
                </button>
                <button className="w-[72px] h-[72px] rounded-2xl flex flex-col items-center justify-center flex-shrink-0 cursor-pointer border border-gray-100" style={{ background: "#F9F9F9" }}>
                  <i className="ri-video-add-line text-gray-300" style={{ fontSize: 20 }} />
                  <span className="text-xs text-gray-300 mt-1">视频</span>
                </button>
              </div>
              <textarea
                value={text}
                onChange={e => setText(e.target.value.slice(0, 500))}
                placeholder="分享你的旅行故事..."
                className="w-full outline-none text-sm text-gray-700 resize-none leading-relaxed"
                style={{ minHeight: 80, background: "transparent" }}
              />
              <div className="text-xs text-gray-300 text-right mb-3">{text.length}/500</div>
              <div className="flex flex-wrap gap-2 mb-3">
                {["三亚", "大理", "成都", "厦门", "亲子游", "蜜月"].map(t => (
                  <button
                    key={t}
                    onClick={() => toggle(t)}
                    className="px-3 py-1 rounded-full text-xs cursor-pointer transition-all whitespace-nowrap"
                    style={{
                      background: tags.includes(t) ? "#FFF3EE" : "#F5F5F5",
                      color: tags.includes(t) ? BRAND : "#888",
                      border: `1px solid ${tags.includes(t) ? "#FFB99A" : "transparent"}`,
                      fontWeight: tags.includes(t) ? 600 : 400,
                    }}
                  >#{t}</button>
                ))}
              </div>
              <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                <div className="flex items-center gap-1.5 text-sm text-gray-500">
                  <i className="ri-map-pin-line" style={{ color: BRAND, fontSize: 14 }} />上海市 · 徐汇区
                </div>
                <button className="text-xs font-medium cursor-pointer whitespace-nowrap" style={{ color: BRAND }}>修改</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default function DiscoverPage() {
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);
  const [search, setSearch] = useState("");

  const left = discoverPosts.filter((_, i) => i % 2 === 0);
  const right = discoverPosts.filter((_, i) => i % 2 === 1);

  return (
    <div className="min-h-screen pb-10" style={{ background: "#F7F7F7", fontFamily: "'SF Pro Text','PingFang SC','Inter',system-ui,sans-serif" }}>

      {/* ── Top bar ── */}
      <div
        className="sticky top-0 z-40 bg-white px-4 pb-0"
        style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 48px)", borderBottom: "1px solid #F0F0F0" }}
      >
        {/* Row 1: location + search + bell */}
        <div className="flex items-center gap-2.5 pb-3">
          <button className="flex items-center gap-1 cursor-pointer flex-shrink-0">
            <i className="ri-map-pin-2-fill" style={{ color: BRAND, fontSize: 13 }} />
            <span className="text-sm font-bold text-gray-900">上海</span>
            <i className="ri-arrow-down-s-line text-gray-400" style={{ fontSize: 12 }} />
          </button>
          <div className="flex-1 flex items-center gap-2 rounded-xl px-3 py-2.5 bg-gray-100">
            <i className="ri-search-line text-gray-400" style={{ fontSize: 14 }} />
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="搜索目的地、旅行攻略..."
              className="flex-1 bg-transparent outline-none text-gray-700 text-sm"
              style={{ fontSize: 13 }}
            />
          </div>
          <button className="relative w-9 h-9 flex items-center justify-center rounded-xl bg-gray-100 cursor-pointer flex-shrink-0">
            <i className="ri-notification-3-line text-gray-600" style={{ fontSize: 17 }} />
            <span className="absolute top-1.5 right-1.5 w-[7px] h-[7px] rounded-full bg-red-500 border-2 border-white" />
          </button>
        </div>
        {/* Row 2: tabs */}
        <div className="flex gap-5">
          {tabs.map((t, i) => (
            <button
              key={t}
              onClick={() => setTab(i)}
              className="pb-2.5 text-sm cursor-pointer relative whitespace-nowrap"
              style={{ color: tab === i ? "#1A1A1A" : "#ACACAC", fontWeight: tab === i ? 700 : 400 }}
            >
              {t}
              {tab === i && (
                <span
                  className="absolute bottom-0 left-1/2 -translate-x-1/2 rounded-full"
                  style={{ width: 18, height: 2.5, background: BRAND, display: "block" }}
                />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* ── Banner ── */}
      <HomeBanner onNav={navigate} />

      {/* ── Quick entries ── */}
      <div className="mx-4 mt-3 grid grid-cols-4 gap-2">
        {entries.map(e => (
          <button
            key={e.label}
            onClick={() => navigate(e.path)}
            className="flex flex-col items-center gap-1.5 pt-3 pb-3 rounded-2xl cursor-pointer active:scale-95 transition-all"
            style={{ background: e.bg }}
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/70">
              <i className={e.icon} style={{ color: e.color, fontSize: 20 }} />
            </div>
            <span className="text-xs font-semibold" style={{ color: "#333" }}>{e.label}</span>
          </button>
        ))}
      </div>

      {/* ── Community header ── */}
      <div className="mx-4 mt-4 flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <span className="w-[3px] h-4 rounded-full inline-block" style={{ background: BRAND }} />
          <span className="text-sm font-bold text-gray-900">旅行社区</span>
        </div>
        <div className="flex gap-1.5">
          {[{ icon: "ri-fire-fill", label: "热门" }, { icon: "ri-time-line", label: "最新" }].map(x => (
            <button
              key={x.label}
              className="flex items-center gap-1 text-xs px-3 py-1.5 rounded-full cursor-pointer whitespace-nowrap"
              style={{ background: "#F0F0F0", color: "#666" }}
            >
              <i className={x.icon} style={{ fontSize: 11 }} />{x.label}
            </button>
          ))}
        </div>
      </div>

      {/* ── Waterfall ── */}
      <div className="px-4 pt-3 pb-4">
        <div className="flex gap-3">
          <div className="flex-1 space-y-3">
            {left.map(p => <PostCard key={p.id} post={p} />)}
          </div>
          <div className="flex-1 space-y-3" style={{ marginTop: 20 }}>
            {right.map(p => <PostCard key={p.id} post={p} />)}
          </div>
        </div>
      </div>

      <PublishFAB />
    </div>
  );
}
